<template>
    <div class="modal" tabindex="-1"
         role="dialog"
         ref="subscribe-newsletter-modal"
         id="subscribe_newsletter_modal">

        <div class="modal-dialog modal-lg" role="document">

            <div class="modal-content">

                <div class="modal-header">
                    <h4 class="modal-title">
                        Get weekly update on news from Mergerfilers
                    </h4>
                    <button type="button" class="btn-close btn-close-white"
                            data-bs-dismiss="modal"
                            aria-label="Close"></button>
                </div>

                <div class="modal-footer mt-5 justify-content-center">
                    <button type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">
                        Not now
                    </button>
                    <button type="button"
                            @click="subscribeHandler"
                            class="btn btn-primary">
                        Get updates
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, onMounted, reactive, useTemplateRef, watch} from "vue";
import {useRouter} from "vue-router";
import Modal from "bootstrap/js/dist/modal";

import {useMainStore} from "@/stores/mainStore";


interface State {
    isUserLogged: boolean
}


const router = useRouter();
const modalElement = useTemplateRef<HTMLDivElement>('subscribe-newsletter-modal')

const mainStore = useMainStore();

let myModal: Modal;
let timeOutId: number | null = null


const state: State = reactive({
    isUserLogged: computed<boolean>(() => !!mainStore.getLoggedUser),
})


onMounted(() => {
    if (modalElement.value) {
        myModal = new Modal(modalElement.value, {
            keyboard: false
        })
        // console.debug('newsletter modal mounted ')
        const sessionInvite = sessionStorage.getItem('newsletterInvite')

        if (!sessionInvite) {
            // console.debug('invite not found, setting the timer for the invite... ')
            timeOutId = setTimeout(() => {
                myModal.show()
                sessionStorage.setItem('newsletterInvite', 'true')
            }, 2 * 60 * 1000)
        }

    }
})

watch(() => state.isUserLogged,
    (value) => {
        if (value && timeOutId) {
            // console.debug('user logged in, cleaning timeout...')
            clearTimeout(timeOutId)
        }
    }
)


const subscribeHandler = () => {
    myModal.hide();
    router.push({name: 'home', hash: '#newsletterForm'})
}

</script>


<style scoped>

</style>
